"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _axios = _interopRequireDefault(require("axios"));

var _frontlibUtil = require("@figure/frontlib-util");

var _this = void 0;

var TypeaheadContainer = function TypeaheadContainer(_ref) {
  var children = _ref.children,
      cancelable = _ref.cancelable,
      debounce = _ref.debounce,
      disabled = _ref.disabled,
      id = _ref.id,
      onAutocompleteSelection = _ref.onAutocompleteSelection,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      selectOption = _ref.selectOption,
      setSelection = _ref.setSelection,
      url = _ref.url,
      value = _ref.value;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      results = _useState2[0],
      setResults = _useState2[1];

  var debouncedValue = (0, _frontlibUtil.useDebounce)(value, debounce);
  var cancelRef = (0, _react.useRef)(null);

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      statusMessage = _useState4[0],
      setStatusMessage = _useState4[1];

  var _useState5 = (0, _react.useState)(null),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      highlightedIndex = _useState6[0],
      setHighlightedIndex = _useState6[1];

  var totalResults = results.length;
  (0, _react.useEffect)(function () {
    if (cancelable) {
      var handleClick = function handleClick() {
        if (cancelRef.current) {
          cancelRef.current.cancel();
          cancelRef.current = null;
        }

        setResults([]);
      };

      window.addEventListener('click', handleClick);
      return function () {
        window.removeEventListener('click', handleClick);
      };
    }
  }, [cancelable]);
  (0, _react.useEffect)(function () {
    var didCancel = false;
    if (disabled || !debouncedValue) return;
    if (cancelRef.current) cancelRef.current.cancel();
    cancelRef.current = _axios.default.CancelToken.source();
    (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var result;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _axios.default.get("".concat(url).concat(debouncedValue), {
                cancelToken: cancelRef.current.token
              });

            case 3:
              result = _context.sent;
              if (!didCancel) setResults(result.data);
              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              if (!didCancel && !_axios.default.isCancel(_context.t0)) setResults([]);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }))();
    return function () {
      didCancel = true;
    };
  }, [debouncedValue, disabled, url]);
  (0, _react.useEffect)(function () {
    if (totalResults === 0) {
      setStatusMessage('');
      return;
    }

    var withResults = "".concat(totalResults, " ").concat(totalResults === 1 ? 'result is' : 'results are', " available. Use up and down arrow keys to navigate. Press Enter key to select.");
    setStatusMessage(withResults);
    return function () {
      setStatusMessage('');
    };
  }, [results, statusMessage, totalResults]);

  var hideMenu = function hideMenu() {
    setResults([]);
    setHighlightedIndex(null);
  };

  var handleOnChange = function handleOnChange(e) {
    // Close the menu if the user deletes all letters they've typed
    if (!e.target.value) {
      hideMenu();
    }

    onChange(e.target.value);
  };

  var onCopy = function onCopy() {
    return setHighlightedIndex(null);
  }; // ARIA setup


  var labelId = "".concat(id, "-label");
  var menuId = "".concat(id, "-menu");

  var getOptionId = function getOptionId(index) {
    return "".concat(menuId, "-option-").concat(index);
  };

  var inputKeyDownHandlers = {
    ArrowDown: function ArrowDown(e) {
      e.preventDefault(); // ArrowDown should not increase the highlightedIndex when the dropdown menu is closed

      if (totalResults === 0) {
        return;
      } // ArrowDown should highlight the first option both the first time it is pressed and when the final option is currently highlighted
      // If the menu is open and no option is highlighted, aria-activedescendant attribute should be added to the input the first time ArrowDown is pressed


      if (typeof highlightedIndex !== 'number' || highlightedIndex >= totalResults - 1) {
        setHighlightedIndex(0);
        return;
      } // ArrowDown should highlight the next option if an option is currently highlighted.
      // It should also cause aria-activedescendant to match the item with aria-selected="true"


      setHighlightedIndex(function (previousValue) {
        return previousValue + 1;
      });
    },
    ArrowUp: function ArrowUp(e) {
      e.preventDefault(); // ArrowUp should not decrease the highlightedIndex when the dropdown menu is closed

      if (totalResults === 0) {
        return;
      } // ArrowUp should highlight the last option if either no result or the first option is currently highlighted
      // If the menu is open and no option is highlighted, aria-activedescendant attribute should be added to the input the first time ArrowDown is pressed


      if (typeof highlightedIndex !== 'number' || highlightedIndex === 0) {
        setHighlightedIndex(totalResults - 1);
        return;
      } // ArrowUp should highlight the previous option if an option is currently highlighted
      // It should cause aria-activedescendant to match the item with aria-selected="true"


      setHighlightedIndex(function (previousValue) {
        return previousValue - 1;
      });
    },
    ArrowLeft: function ArrowLeft() {
      // If an option in the menu is highlighted and ArrowLeft is pressed,
      // the menu should stay open, aria-selected should be false, and aria-activedescendant should be removed from the input
      if (highlightedIndex >= 0) {
        setHighlightedIndex(null);
      }
    },
    ArrowRight: function ArrowRight() {
      // If an option in the menu is highlighted and ArrowRight is pressed,
      // the menu should stay open, aria-selected should be false, and aria-activedescendant should be removed from the input
      if (highlightedIndex >= 0) {
        setHighlightedIndex(null);
      }
    },
    Enter: function Enter(e) {
      e.preventDefault(); // Enter should do nothing when either the dropdown menu is closed or an option is not selected

      if (typeof highlightedIndex !== 'number' || totalResults === 0) {
        return;
      }

      selectOption(results[highlightedIndex]);
      hideMenu();
    },
    Tab: function Tab() {
      hideMenu();
    },
    Escape: function Escape(e) {
      e.preventDefault(); // Escape should clear the text input and any result that has been selected

      onAutocompleteSelection('');
      setSelection(null); // Escape should close an open dropdown menu

      if (totalResults > 0) {
        hideMenu();
      }
    },
    Home: function Home() {
      // Home should move cursor to the beginning of the text input, unhighlight options, and remove aria-activedescendant
      setHighlightedIndex(null);
    },
    End: function End() {
      // End should move the cursor after any text in the input, unhighlight options, and remove aria-activedescendant
      setHighlightedIndex(null);
    }
  };

  var handleKeyDown = function handleKeyDown(e) {
    var key = e.key;

    if (key && inputKeyDownHandlers[key]) {
      inputKeyDownHandlers[key].call(_this, e);
    } // If an option in the menu is highlighted and user starts to type,
    // the menu should stay open, aria-selected should be false, and aria-activedescendant should be removed from the input


    if (key && !inputKeyDownHandlers[key] && highlightedIndex > 0) {
      setHighlightedIndex(null);
    }

    return;
  };

  var inputProps = {
    type: 'text',
    id: id,
    value: value,
    onChange: handleOnChange,
    onFocus: onFocus,
    onBlur: onFocus,
    onKeyDown: handleKeyDown,
    onCopy: onCopy,
    role: 'combobox',
    'aria-autocomplete': 'list',
    'aria-controls': totalResults > 0 ? menuId : null,
    'aria-expanded': totalResults > 0 ? 'true' : 'false',
    'aria-activedescendant': totalResults > 0 && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? getOptionId(highlightedIndex) : null
  };
  var childrenProps = {
    hideMenu: hideMenu,
    highlightedIndex: highlightedIndex,
    inputProps: inputProps,
    labelId: labelId,
    menuId: menuId,
    results: results,
    statusMessage: statusMessage
  };
  return /*#__PURE__*/_react.default.createElement("div", null, children(childrenProps));
};

TypeaheadContainer.displayName = 'TypeaheadContainer';
TypeaheadContainer.propTypes = {
  /** If typeahead rows are cancelable */
  cancelable: _propTypes.default.bool,

  /** Used to render the input, label, and menu */
  children: _propTypes.default.func.isRequired,

  /** Length of the debounce for the autocomplete */
  debounce: _propTypes.default.number,

  /** Used to determine if data should be fetched */
  disabled: _propTypes.default.bool.isRequired,

  /** The id of the input */
  id: _propTypes.default.string.isRequired,

  /** Callback function to run when a selection is made on the autocomplete */
  onAutocompleteSelection: _propTypes.default.func.isRequired,

  /** Used to update the value */
  onChange: _propTypes.default.func.isRequired,

  /** Used to handle onFocus and onBlur events */
  onFocus: _propTypes.default.func,

  /** Handles selecting an option with the `Enter` key */
  selectOption: _propTypes.default.func.isRequired,

  /** Used to update the selected result */
  setSelection: _propTypes.default.func.isRequired,

  /** URL to fetch the results from */
  url: _propTypes.default.string.isRequired,

  /** Used to control the input */
  value: _propTypes.default.string
};
TypeaheadContainer.defaultProps = {
  cancelable: false,
  debounce: 100,
  onFocus: null,
  value: ''
};
var _default = TypeaheadContainer;
exports.default = _default;